// Small Terracotta dot signaling unresolved drift or failed runs. Per
// dashboard-shell.md §3, this is one of the four places the brand accent
// appears in chrome. Always paired with a count in the aria-label for the
// Status-Always-Doubled rule.

export function AttentionPip({ count, className = '' }) {
  if (!count || count <= 0) return null
  const label = count === 1 ? '1 unresolved item' : `${count} unresolved items`
  return (
    <span
      aria-label={label}
      role="status"
      className={`inline-block h-1.5 w-1.5 rounded-full bg-[var(--color-terracotta)] ${className}`}
    />
  )
}
